/* eslint-disable operator-linebreak */
import { createAction } from '@reduxjs/toolkit';

export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';
export const SET_CHANGE_PASSWORD_ERROR = 'SET_CHANGE_PASSWORD_ERROR';
export const SET_CHANGE_PASSWORD_SUCCESS = 'SET_CHANGE_PASSWORD_SUCCESS';
export const SET_RESET_ERROR_AND_MESSAGE = 'SET_RESET_ERROR_AND_MESSAGE';
export interface ISetNewPasswordRequest {
	oldPassword: string;
	newPassword: string;
	confirmNewPassword: string;
}

export const setNewPasswordAction =
	createAction<ISetNewPasswordRequest>(SET_NEW_PASSWORD);

export const setChangePasswordSuccesAction = createAction<string>(
	SET_CHANGE_PASSWORD_SUCCESS
);

export const setErrorChangePasswordAction = createAction<string>(
	SET_CHANGE_PASSWORD_ERROR
);

export const setResetErrorAndMessageAction = createAction<string>(
	SET_RESET_ERROR_AND_MESSAGE
);
